import '../styles/footer/footer.css';
import { captureEvent } from '../lib/analytics';
import { goToSectionAnywhere } from '../lib/router';
import { OPEN_COOKIE_SETTINGS } from '../lib/consentEvents';

const NAV_LINKS = [
    { id: 'about', label: 'Over mij' },
    { id: 'projects', label: 'Projecten' },
    { id: 'services', label: 'Diensten' },
    { id: 'contact', label: 'Contact' },
] as const;

const IPHONE_MODEL_URL = 'https://sketchfab.com/3d-models/iphone-17-pro-4541aa8a28324b33a2baaf81d263aaec';

/* Closes the page on ink, continuing the contact section. Leaves room for the dock. */
const Footer = () => (
    <footer className="footer" data-theme="dark" data-menu-inert>
        <div className="container footer__inner">
            <div className="footer__cols">
                <nav aria-label="Voetnavigatie" className="footer__col">
                    <p className="label">Navigatie</p>
                    <ul>
                        {NAV_LINKS.map((link) => (
                            <li key={link.id}>
                                <a
                                    className="link"
                                    href={`#${link.id}`}
                                    onClick={(event) => {
                                        event.preventDefault();
                                        captureEvent('nav_link_clicked', { section: link.id, menu: 'footer' });
                                        goToSectionAnywhere(link.id);
                                    }}
                                >
                                    {link.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>

                <div className="footer__col">
                    <p className="label">Bedrijfsgegevens</p>
                    <address>
                        <span className="brand">Schmitt Software</span>
                        <span>Alexander Schmitt</span>
                        <span>Geel, Antwerpen, België</span>
                        <span>BE 1001.491.940, Student-eenmanszaak</span>
                    </address>
                </div>

                <div className="footer__col">
                    <p className="label">Juridisch</p>
                    <ul>
                        <li>
                            <a className="link" href="/privacy-policy.php">
                                Privacybeleid
                            </a>
                        </li>
                        <li>
                            <a className="link" href="/terms-conditions.php">
                                Algemene voorwaarden
                            </a>
                        </li>
                        <li>
                            <button
                                type="button"
                                className="link footer__button"
                                onClick={() => window.dispatchEvent(new Event(OPEN_COOKIE_SETTINGS))}
                            >
                                Cookie-instellingen
                            </button>
                        </li>
                    </ul>
                </div>
            </div>

            <p className="footer__wordmark display" aria-hidden="true">
                Schmitt Software
            </p>

            <div className="footer__fine">
                <p className="footer__legal">
                    © {new Date().getFullYear()} <span className="brand">Schmitt Software</span>. Alle rechten voorbehouden.
                </p>

                {/* CC BY 4.0 asks for the title, the maker, the source, the licence and a note on changes. */}
                <p className="footer__credits">
                    3D-model{' '}
                    <a className="link" href={IPHONE_MODEL_URL} target="_blank" rel="noopener noreferrer">
                        iPhone 17 Pro
                    </a>{' '}
                    door{' '}
                    <a className="link" href="https://sketchfab.com/Ranguel" target="_blank" rel="noopener noreferrer">
                        Ranguel
                    </a>
                    , licentie{' '}
                    <a className="link" href="https://creativecommons.org/licenses/by/4.0/" target="_blank" rel="noopener noreferrer">
                        CC BY 4.0
                    </a>
                    . Aangepast voor deze site: gecomprimeerd en met een eigen schermbeeld.
                </p>
            </div>
        </div>
    </footer>
);

export default Footer;
